import { CognitiveLoadBreakdown as CognitiveLoadBreakdownComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

interface CognitiveLoadBreakdownProps {
    isInsideModal?: boolean;
    subDimensionsData?: any;
}

const CognitiveLoadBreakdown = ({
    isInsideModal,
    subDimensionsData,
}: CognitiveLoadBreakdownProps) => {
    const {
        cognitiveLoadBreakdownData,
        isFetchingCognitiveLoadBreakdown,
        isErrorCognitiveLoadBreakdown,
    } = useSessionDetailsContext();

    if (isFetchingCognitiveLoadBreakdown) {
        return <ContentLoader height="21.1875rem" />;
    }

    if (!isInsideModal && isErrorCognitiveLoadBreakdown && !isFetchingCognitiveLoadBreakdown) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="18.1875rem"
                />
            </ComponentWrapper>
        );
    }

    const isEmptyState = () => {
        if (isInsideModal) {
            return !subDimensionsData || subDimensionsData?.length === 0;
        } else if (
            !isErrorCognitiveLoadBreakdown &&
            (!cognitiveLoadBreakdownData || cognitiveLoadBreakdownData.length === 0)
        ) {
            return true;
        }
    };

    if (isEmptyState()) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-details:cognitive-load:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight="18.1875rem"
                />
            </ComponentWrapper>
        );
    }

    return (
        <CognitiveLoadBreakdownComponent
            data={isInsideModal ? subDimensionsData : cognitiveLoadBreakdownData}
        />
    );
};

export default CognitiveLoadBreakdown;
